var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 829,
    height: 534,
    viewBox: "0 0 829 534",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.9059,
    y: 2,
    width: 805.971,
    height: 529.926,
    stroke: "#FFCD83",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8227 0C87.4865 10.2567 79.4306 19.8893 66.6869 27.4956C54.1839 34.9582 37.5867 40.1691 18.9059 41.7904V45.8049C58.2488 42.4851 89.2331 23.647 93.9164 0H89.8227Z",
    fill: "#FFCD83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M829 40.7611C809.508 39.3471 792.174 34.0344 779.229 26.3077C766.978 18.9958 759.06 9.81135 756.39 -1.7969e-06L752.258 -1.90471e-06C757.82 23.4824 789.381 41.9759 829 44.7712L829 40.7611Z",
    fill: "#FFCD83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M756.351 534C758.688 523.743 766.744 514.111 779.487 506.504C791.99 499.042 808.587 493.831 827.268 492.21L827.268 488.195C787.925 491.515 756.941 510.353 752.258 534L756.351 534Z",
    fill: "#FFCD83"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7711 482.353C35.9165 486.717 50.3054 494.5 59.4333 503.937C68.09 512.886 71.8246 523.069 70.0685 533.144L74.1275 533.793C78.9376 510.252 56.4707 487.513 19.4141 478.693L17.7711 482.353Z",
    fill: "#FFCD83"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.6b19c49a3514d4709540553acb10be77.svg";
export { ForwardRef as ReactComponent };